(function(angular){
	'use strict';
	
	var toastContainerObject = {
		bindings: {
			toasts: '<'
		},
		controller: [
			'$q',
			'$timeout',
			ToastContainerFunction
		],
		controllerAs: 'toastContainer',
		template: '<toast ng-repeat="toast in toastContainer.toasts" index="$index" message="toast.message" type="toast.type"></toast>'
	};
	
	angular
		.module('toastModule')
		.component('toastContainer', toastContainerObject);
	
	function ToastContainerFunction(
		$q,
		$timeout
	){
		var toastContainer = this;

		toastContainer.remove = function(toastIndex) {
			toastContainer.toasts.splice(toastIndex, 1);
		};
	}
})(window.angular);